import React from 'react';
import { Formik, Field } from 'formik';
import { Form } from 'react-bootstrap';
import { StackedText, StackedDatePicker } from '@tpco/blueprint-react';

const CreateConfigurationForm = ({
  onFormSubmit,
  nameValidation,
  validateStartDate,
  validateEndDate,
  initialValues,
  formName
}) => {
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={values => {
        onFormSubmit(values);
      }}
      enableReinitialize={false}
    >
      {({ handleSubmit, values }) => (
        <Form className="card edit-campaign__container" onSubmit={handleSubmit}>
          <h4 className="edit-campaign__title">{formName}</h4>

          <StackedText
            htmlId="edit-p3-name"
            fieldName="name"
            labelText="Name"
            className="form-group__col-flex-column saturn-form-group saturn-col saturn-flex-column"
            validate={nameValidation}
          />
          <StackedDatePicker
            className="edit-campaign__date hide"
            labelText="Start Date"
            htmlId="edit-campaign-start-date"
            fieldName="startDate"
            validate={(value: any) => validateStartDate(value, values)}
          />
          <StackedDatePicker
            className="edit-campaign__date hide"
            labelText="End Date"
            htmlId="edit-campaign-end-date"
            fieldName="endDate"
            validate={(value: any) => validateEndDate(value, values)}
          />
          <div className="form-group__col-flex-column saturn-form-group saturn-col saturn-flex-column">
            <label className="label">Description</label>
          </div>
          <div className="form-group__col-flex-column saturn-form-group saturn-col saturn-flex-column">
            <Field
              fieldname="description"
              name="description"
              component="textarea"
              className="textarea"
            />
            <div className="edit-campaign__submit">
              <button className="btn btn-primary" type="submit">
                {formName.includes('Create') ? <span>Create</span> : <span>Open</span>}
              </button>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default CreateConfigurationForm;
